<template>
  <div class="quick">
	<div class="listUl">
		<ul class="hidden-sm-and-down">
		   <li class="logined"  v-show="userInfo">
			   <div class="usernamem">
				    欢迎您：<a :title="UserName" href="javascript:void(0);" class="username">{{UserName}}</a>
			   </div>
			   <a  style="cursor: pointer;color:#ffab22" @click="LoginOut">退出</a> 本系统！</li>
		   <li v-show="!userInfo"><a @click="goReg()" href="javascript:void(0);"><span class="login-img"><img src="../assets/images/listImg4.png" v-if="!userInfo"></span><span class="login-text">作者在线注册</span></a></li>
		   <li v-if = "userInfo?userInfo.RoleID.indexOf('Authors')!=-1:true"><a @click="goLogin(1)"  href="javascript:void(0);"><span class="login-img"><img src="../assets/images/listImg3.png" v-if="!userInfo"></span><span class="login-text">{{userInfo?"进入":""}}作者投稿查稿</span></a></li>
		   <li v-if = "userInfo?userInfo.RoleID.indexOf('Editors')!=-1:true"><a @click="goLogin(2)"><span class="login-img"><img src="../assets/images/listImg2.png" v-if="!userInfo"></span><span class="login-text">{{userInfo?"进入":""}}编辑在线办公</span></a></li>
		   <li v-if = "userInfo?userInfo.RoleID.indexOf('Experts')!=-1:true"><a @click="goLogin(3)"><span class="login-img"><img src="../assets/images/listImg1.png" v-if="!userInfo"></span><span class="login-text">{{userInfo?"进入":""}}专家在线审稿</span></a></li>
		 </ul>
		 <div class="clearfix"></div>
		 <ul class="hidden-md-and-up">
		   <li v-show="!userInfo"><a style="cursor: pointer;" @click="goReg()">作者在线注册</a></li>
		   <li v-show="userInfo"><a style="cursor: pointer;" @click="LoginOut">退出本系统！</a></li>
		   <li v-for="(item,index) in Systemlist" :Key="item" v-if = "userInfo?userInfo.RoleID.indexOf(type[index])!=-1:true" @click="goLogin(index+1)"><a href="javascript:void(0);">{{item}}</a></li>
		 </ul>
	</div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
    export default {
        name: "Logincontrol",
      data(){
          return{
            Systemlist:[
              "作者投稿查稿",
			  "编辑在线办公",
			  "专家在线审稿"
            ],
			userInfo:"",
			UserName:"",
			type:["Authors","Editors","Experts"]
          }
      },
	  created() {
	  	this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"))
		if(this.userInfo){
			this.UserName = this.userInfo.UserName
		}
	  },
	  methods:{
		  LoginOut(){
			//退出登录
			window.localStorage.removeItem("userInfo")
			sessionStorage.removeItem('eqcode');
			location.reload() 
		  },
		  goLogin(num){
			 
			  if(window.localStorage.getItem("userInfo")){
				 if(num==1){
				 	var urldomain = "/author/#/";
				 	window.location.href=urldomain;
				    return  						
				  }else if(num==2){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/editor/#/editor/Index";
				 	 window.location.href=urldomain;
				  return  					       
				  }else if(num==3){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/expert/#/examine-manuscripts";
				 	 window.location.href=urldomain;
				 	 return 					 	 
				 	 }	
			  }else{
				  //num 1-作者 2-编辑办公 3-专家审稿
				  window.sessionStorage.setItem("Login",num)
				  this.$router.push({
				    path: '/Login'// 跳转至登录
				  })
			  }
		  },
		  goReg(){
			  this.$router.push({
			    path: '/regist'// 跳转至登录
			  })
		  }
	  }
    }
</script>

<style scoped>
.login-img img{
	margin-right: 5px;
}
.quick{
	margin-bottom: 18px;
}
.logined{
	line-height: 30px;
}

.usernamem{
	width: 80%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 15px;
}
@media (max-width:768px){
.quick{ margin-top:-40px !important; margin-bottom: 0 !important;}
}
</style>
